import {
  empty,
  jsonImageCaptionWrapperClass,
  jsonImageCaptionOverlayClass,
  jsonImageCaptionOverlayStyle,
  jsonImageCaptionStyle,
  TooltipText,
  JsonImgNodeProps
} from 'components/shared';
import { getTheme, mergeStyles, Stack, Text } from '@fluentui/react';
import React, { useEffect, useRef, useState } from 'react';
import { JsonContentValidationMessage } from './JsonContentValidationMessage';
import { generateImageFilters } from '../../../util/smallFuncs';
import { DEFAULT_MAX_MEDIA_HEIGHT } from '../../../admin/MediaHeightField';

// We use these 'static' colors in the case when we don't want color to change between light mode and dark mode.
const NeutralDarkStatic = '#201f1e';
export const ImageUrlType: React.FunctionComponent<JsonImgNodeProps> = (props): JSX.Element => {
  const [filename, setFilename] = useState('');
  const imageRef = useRef<HTMLImageElement>(null);
  useEffect(() => {
    if (imageRef.current) {
      const src = props.value;
      const parts = src.split('/');
      const filenameWithExtension = parts[parts.length - 1];
      const filename = filenameWithExtension.split('.')[0];
      setFilename(filename);
    }
  });
  const { palette, fonts } = getTheme();
  const imgWrapperAdditionalClass = 'position-relative';
  const imgWrapperClass = mergeStyles(
    {
      backgroundColor: NeutralDarkStatic
    },
    imgWrapperAdditionalClass
  );
  const imgUrlValidationMessageClass = mergeStyles(
    {
      minHeight: props.isZoomInActive ? 500 : ''
    },
    'ml-3'
  );

  const imageFilter = generateImageFilters(props.subjectImagePreferences);
  const baseStyle = props.isGridView
    ? { width: '100%', height: (props.uxPreferences?.maxCardHeight || 300) - (props.extraHeight || 0) }
    : {};

  const zoominStyles = {
    maxHeight: `${props.subjectImagePreferences?.maxHeight || DEFAULT_MAX_MEDIA_HEIGHT}px`,
    maxWidth: '100%'
  };
  return (
    <Stack className={imgWrapperClass} style={zoominStyles}>
      {!empty(props.caption) && (
        <>
          <Stack className={jsonImageCaptionOverlayClass} style={jsonImageCaptionOverlayStyle(palette)}></Stack>
          <Stack className={jsonImageCaptionWrapperClass(props.isZoomInActive)}>
            <Text style={jsonImageCaptionStyle(palette, fonts, 'white', 'large')}>{props.caption}</Text>
          </Stack>
        </>
      )}
      <Stack.Item
        className="overflow-hidden"
        style={props.isZoomInActive ? {} : { maxHeight: '100%', maxWidth: '100%' }}
      >
        {!empty(props.value) ? (
          <img
            alt={filename || props.value}
            src={props.value}
            ref={imageRef}
            className="d-block mx-auto"
            style={props.isZoomInActive ? zoominStyles : { ...baseStyle, ...imageFilter }}
          />
        ) : (
          <div className="mt-4 pt-3">
            <JsonContentValidationMessage
              message={TooltipText.imageUrlTypeValidationMessage}
              validationMessageWrapperClass={imgUrlValidationMessageClass}
            />
          </div>
        )}
      </Stack.Item>
    </Stack>
  );
};
